<template lang="pug">

</template>

<script>

import GameApi from '@/plugins/GameApi'

export default {
  async mounted () {
    let starship = await GameApi.loadMyStarship()
    this.$router.replace(`/starship/${starship._id}`)
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/starship/index.vue